import React, { useContext } from "react";
import ProviderPage from "./pageProvider";
import { ContextPage } from "./pageContext";
import Layout from "../layouts";
import Content from "../content";
import "./styles.css";

// Каркас экрана: провайдер страницы + layout; при withContent дети оборачиваются
// в <Content> с обработчиками навигации после create/delete.
// Роутер (view/pages/index.js) сам передаёт route/routes/type/withContent.
// withEdit/withDestroy/withDestroyOnShow — тонкая настройка Content (разделы без
// редактирования и/или без удаления).
export default function Page({ children, ApiModel, withEdit = true, withDestroy = true, withDestroyOnShow = false, ...other }) {
    return <ProviderPage {...other}>
        <PageView ApiModel={ApiModel} withEdit={withEdit} withDestroy={withDestroy} withDestroyOnShow={withDestroyOnShow}>
            {children}
        </PageView>
    </ProviderPage>;
}

function PageView({ ApiModel, withEdit, withDestroy, withDestroyOnShow, children }) {
    const contextPage = useContext(ContextPage);

    // Успешное создание → на карточку новой записи (ключ роута — withContentKeyRoute)
    const handleDoCreate = (data) => {
        if (data && data[contextPage.withContentKeyRoute] !== undefined) {
            contextPage.goPageShow(data[contextPage.withContentKeyRoute]);
        } else {
            contextPage.goPageIndex();
        }
    };

    // Успешное удаление → на список
    const handleDoDelete = () => contextPage.goPageIndex();

    return <Layout>
        <div className="page">
            {contextPage.withContent
                ? <Content
                    ApiModel={ApiModel}
                    type={contextPage.type}
                    withEdit={withEdit}
                    withDestroy={withDestroy}
                    withDestroyOnShow={withDestroyOnShow}
                    handleDoCreate={handleDoCreate}
                    handleDoDelete={handleDoDelete}
                >
                    {children}
                </Content>
                : children}
        </div>
    </Layout>;
}
